import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { API_CONSTANTS } from '../constants';
import { NightwebUtil } from '../utils';
import { HttpClientService } from './http-client.service';
import { OrganizationSettingsService } from './organization-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(
    private http: HttpClientService,
    private nightwebUtil: NightwebUtil,
    private organizationSettings: OrganizationSettingsService,
  ) { }

  getAllAdministrators(query?: any) {
    return this.http.get(API_CONSTANTS.ADMINS, query)
    .pipe(
      map((res: any) => {
        if (res?.data?.rows) {
          res.data.rows = res.data.rows.map((admin: any) => {
            admin.displayName = this.nightwebUtil.getDisplayName(admin.demographic);
            return admin;
          });
        }
        return res;
      })
    );
  }

  getById(id: any) {
    return this.http.get(API_CONSTANTS.ADMINS + `/${id}`)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getSelf() {
    return this.http.get(API_CONSTANTS.ADMINS + API_CONSTANTS.SELF)
    .pipe(
      map((res: any) => {
        return res;
      }),
      tap((res: any) => {
        if (res?.data) {
          this.organizationSettings.applyFromAdminSelfPayload(res.data);
        }
      }),
    );
  }

  updateSelf(data: any) {
    return this.http.put(API_CONSTANTS.ADMINS + API_CONSTANTS.SELF, data)
      .pipe(
        map((res: any) => {
          return res;
        }),
        tap((res: any) => {
          if (res?.data) {
            this.organizationSettings.applyFromAdminSelfPayload(res.data);
          }
        }),
      );
  }

  getAdvocates(query?: any) {
    return this.http.get(API_CONSTANTS.ADMINS + API_CONSTANTS.ADVOCATES, query)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  invite(id: any) {
    return this.http.get(API_CONSTANTS.ADMINS + `/${id}` + '/invite')
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  create(data: any) {
    return this.http.post(API_CONSTANTS.ADMINS, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  addAdmin(data: any) {
    return this.http.post(API_CONSTANTS.ADMINS, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  update(data: any) {
    return this.http.put(API_CONSTANTS.ADMINS + `/${data.id}`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  delete(id: string) {
    return this.http.remove(API_CONSTANTS.ADMINS + `/${id}`)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  changeStatus(id:string, data: any) {
    return this.http.put(API_CONSTANTS.ADMINS + '/change-status' + `/${id}`, data)
      .pipe(
        map((response: any) => {
          return response;
        })
      )
  }
}
